module.exports = __webpack_public_path__ + "static/media/showOff.dc82d04a.svg";